// Mock data for the trademark registration application

export const countryCodes = [
  { code: '+1', country: 'US', flag: '🇺🇸', name: 'United States' },
  { code: '+44', country: 'GB', flag: '🇬🇧', name: 'United Kingdom' },
  { code: '+91', country: 'IN', flag: '🇮🇳', name: 'India' },
  { code: '+61', country: 'AU', flag: '🇦🇺', name: 'Australia' },
  { code: '+81', country: 'JP', flag: '🇯🇵', name: 'Japan' },
  { code: '+86', country: 'CN', flag: '🇨🇳', name: 'China' },
  { code: '+49', country: 'DE', flag: '🇩🇪', name: 'Germany' },
  { code: '+33', country: 'FR', flag: '🇫🇷', name: 'France' },
  { code: '+39', country: 'IT', flag: '🇮🇹', name: 'Italy' },
  { code: '+7', country: 'RU', flag: '🇷🇺', name: 'Russia' },
  { code: '+55', country: 'BR', flag: '🇧🇷', name: 'Brazil' },
  { code: '+82', country: 'KR', flag: '🇰🇷', name: 'South Korea' },
  { code: '+34', country: 'ES', flag: '🇪🇸', name: 'Spain' },
  { code: '+31', country: 'NL', flag: '🇳🇱', name: 'Netherlands' },
  { code: '+46', country: 'SE', flag: '🇸🇪', name: 'Sweden' },
  { code: '+41', country: 'CH', flag: '🇨🇭', name: 'Switzerland' },
  { code: '+65', country: 'SG', flag: '🇸🇬', name: 'Singapore' },
  { code: '+60', country: 'MY', flag: '🇲🇾', name: 'Malaysia' },
  { code: '+63', country: 'PH', flag: '🇵🇭', name: 'Philippines' },
  { code: '+971', country: 'AE', flag: '🇦🇪', name: 'United Arab Emirates' }
];

export const pricingPackages = [
  {
    id: 'basic',
    name: 'Basic',
    price: 349,
    popular: false,
    features: [
      { name: 'Case Review', included: true },
      { name: 'Case Filing', included: true },
      { name: 'Direct Hit Search', included: true },
      { name: 'Trademark Secured', included: true },
      { name: 'Trademark Alert', included: true },
      { name: '100% Satisfaction Guarantee', included: true }
    ]
  },
  {
    id: 'standard',
    name: 'Standard',
    price: 399,
    popular: true,
    features: [
      { name: 'Case Review', included: true },
      { name: 'Case Filing', included: true },
      { name: 'Direct Hit Search', included: true },
      { name: 'Trademark Secured', included: true },
      { name: 'Trademark Alert', included: true },
      { name: '100% Satisfaction Guarantee', included: true },
      { name: 'Refusal Risk Meter', included: true }
    ]
  },
  {
    id: 'deluxe',
    name: 'Deluxe',
    price: 499,
    popular: false,
    features: [
      { name: 'Case Review', included: true },
      { name: 'Case Filing', included: true },
      { name: 'Direct Hit Search', included: true },
      { name: 'Trademark Secured', included: true },
      { name: 'Trademark Alert', included: true },
      { name: '100% Satisfaction Guarantee', included: true },
      { name: 'Refusal Risk Meter', included: true },
      { name: 'Trademark Monitoring', included: true },
      { name: 'Complete Documentation', included: true },
      { name: 'Digital File', included: true },
      { name: 'Dedicated Case Manager', included: true }
    ]
  },
  {
    id: 'platinum',
    name: 'Platinum',
    price: 549,
    popular: false,
    features: [
      { name: 'Case Review', included: true },
      { name: 'Case Filing', included: true },
      { name: 'Direct Hit Search', included: true },
      { name: 'Trademark Secured', included: true },
      { name: 'Trademark Alert', included: true },
      { name: '100% Satisfaction Guarantee', included: true },
      { name: 'Refusal Risk Meter', included: true },
      { name: 'Trademark Monitoring', included: true },
      { name: 'Complete Documentation', included: true },
      { name: 'Digital File', included: true },
      { name: 'Dedicated Case Manager', included: true },
      { name: '100% Approval Guarantee', included: true },
      { name: 'Comprehensive Trademark Search Report (Federal & State)', included: true },
      { name: '24 Hrs. Expedited Service', included: true },
      { name: 'Cease & Desist Letter', included: true }
    ]
  }
];

export const services = [
  {
    id: 'trademark-registration',
    title: 'Trademark Registration',
    description: 'Secure your brand identity with our expert trademark registration services. We handle all the paperwork and filing to ensure your brand is protected.',
    image: 'https://customer-assets.emergentagent.com/job_brand-registry-2/artifacts/j6aldruh_img-2.jpg',
    features: ['Fast Processing', 'Expert Guidance', 'Affordable Rates'],
    detailedDescription: 'Protect your brand\'s unique identity with our comprehensive trademark registration service. We handle everything from initial search to final approval, ensuring your brand name, logo, or slogan receives the legal protection it deserves.'
  },
  {
    id: 'copyright-registration',
    title: 'Copyright Registration',
    description: 'Protect your original creative works with comprehensive copyright registration. Safeguard your intellectual property rights.',
    image: 'https://customer-assets.emergentagent.com/job_brand-registry-2/artifacts/cmobkklo_img-2.jpg',
    features: ['Quick Filing', 'Legal Protection', 'Peace of Mind'],
    detailedDescription: 'Protect your original work — from books and music to digital content — with our seamless online copyright registration services.'
  },
  {
    id: 'company-formation',
    title: 'Company Formation',
    description: 'Start your business the right way with our business formation services. We help you set up your company structure legally and efficiently.',
    image: 'https://customer-assets.emergentagent.com/job_brand-registry-2/artifacts/4o7kwgsn_img-2.jpg',
    features: ['Complete Setup', 'Legal Compliance', 'Fast Turnaround'],
    detailedDescription: 'Ready to go global? Let us help you form your company in the U.S. with full legal compliance and business setup support.'
  },
  {
    id: 'trademark-search',
    title: 'Trademark Search',
    description: 'Conduct thorough trademark searches to avoid conflicts. Our comprehensive search identifies potential issues before you file.',
    image: 'https://customer-assets.emergentagent.com/job_brand-registry-2/artifacts/woama81a_img-2.jpg',
    features: ['Comprehensive Search', 'Conflict Detection', 'Expert Analysis'],
    detailedDescription: 'We conduct detailed searches to ensure your brand name or logo is available and legally safe to use, avoiding future conflicts.'
  },
  {
    id: 'amazon-brand-registry',
    title: 'Amazon Brand Registry',
    description: 'Protect your brand on Amazon with our Brand Registry services. We guide you through enrollment and help secure your presence.',
    image: 'https://customer-assets.emergentagent.com/job_brand-registry-2/artifacts/eduqqz2w_img-2.jpg',
    features: ['Brand Protection', 'Fast Enrollment', 'Expert Support'],
    detailedDescription: 'Shield your Amazon store from counterfeiters and boost brand with trusted Amazon Brand Registry assistance.'
  }
];

export const testimonials = [
  {
    id: 1,
    name: 'Sarah Mitchell',
    role: 'Boutique Owner',
    image: 'https://images.unsplash.com/photo-1580894732444-8ecded7900cd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHwxfHxidXNpbmVzcyUyMHBlb3BsZXxlbnwwfHx8fDE3NjM0MDEyMzJ8MA&ixlib=rb-4.1.0&q=85',
    rating: 5,
    text: 'Trademark IP US\'s team made trademark registration incredibly simple. They guided me through every step and my brand is now fully protected. Highly recommend their services!'
  },
  {
    id: 2,
    name: 'Michael Chen',
    role: 'Tech Startup Founder',
    image: 'https://images.unsplash.com/photo-1611095790444-1dfa35e37b52?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHwyfHxidXNpbmVzcyUyMHBlb3BsZXxlbnwwfHx8fDE3NjM0MDEyMzJ8MA&ixlib=rb-4.1.0&q=85',
    rating: 5,
    text: 'Professional, efficient, and knowledgeable. Trademark IP US handled our company formation and trademark registration seamlessly. Their expertise saved us countless hours.'
  },
  {
    id: 3,
    name: 'Jennifer Rodriguez',
    role: 'Author',
    image: 'https://images.pexels.com/photos/3183150/pexels-photo-3183150.jpeg',
    rating: 5,
    text: 'I needed copyright protection for my books and Trademark IP US delivered exceptional service. Fast, affordable, and thorough. I now have peace of mind knowing my work is protected.'
  },
  {
    id: 4,
    name: 'David Thompson',
    role: 'E-commerce Seller',
    image: 'https://images.pexels.com/photos/1367269/pexels-photo-1367269.jpeg',
    rating: 5,
    text: 'The Amazon Brand Registry service was a game-changer for my business. Trademark IP US handled everything professionally and now my products are fully protected from counterfeiters.'
  },
  {
    id: 5,
    name: 'Lisa Anderson',
    role: 'Restaurant Owner',
    image: 'https://images.unsplash.com/photo-1600880292203-757bb62b4baf?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHw0fHxidXNpbmVzcyUyMHBlb3BsZXxlbnwwfHx8fDE3NjM0MDEyMzJ8MA&ixlib=rb-4.1.0&q=85',
    rating: 5,
    text: 'From trademark search to final registration, Trademark IP US provided outstanding service. Their detailed search report gave me confidence before investing in my brand. Worth every penny!'
  }
];

export const faqs = [
  {
    id: 1,
    question: 'What is a trademark and why do I need one?',
    answer: 'A trademark is a unique symbol, word, or phrase that identifies and distinguishes your brand from others. It protects your business identity and prevents others from using similar marks that could confuse customers. Having a trademark gives you exclusive legal rights to use that mark in commerce.'
  },
  {
    id: 2,
    question: 'How long does the trademark registration process take?',
    answer: 'The trademark registration process typically takes 8-12 months from filing to approval. However, this timeline can vary depending on the complexity of your application and whether there are any objections or office actions from the USPTO that need to be addressed.'
  },
  {
    id: 3,
    question: 'Can I register a trademark for multiple classes?',
    answer: 'Yes, you can register a trademark for multiple classes of goods or services. Each class represents a different category of products or services. However, you will need to pay additional fees for each class you want to register.'
  },
  {
    id: 4,
    question: 'What are USPTO fees and are they included in your prices?',
    answer: 'USPTO fees are government filing fees required by the United States Patent and Trademark Office. These fees are separate from our service fees and are not included in our package prices. The current USPTO filing fee ranges from $250-$350 per class, depending on the filing basis and application type.'
  },
  {
    id: 5,
    question: 'What happens if my trademark application is rejected?',
    answer: 'If your trademark application receives an office action (rejection or objection), our team will review the reasons and work with you to prepare a response. We handle office actions as part of our service and will do everything possible to overcome the objections and get your trademark approved.'
  }
];

export const statistics = [
  { label: 'Trademarks Registered', value: '10,000+' },
  { label: 'Approval Success Rate', value: '98%' },
  { label: 'States Covered', value: '50' }
];

export const processSteps = [
  {
    step: 1,
    title: 'Submit Your Details',
    description: 'Provide us with your brand name, logo, and basic business information through our secure online form.'
  },
  {
    step: 2,
    title: 'We Handle the Filing',
    description: 'Our experts conduct a trademark search, prepare your application, and file it with the USPTO — accurately and efficiently.'
  },
  {
    step: 3,
    title: 'Get Official Protection',
    description: 'Once approved, your trademark is officially registered, giving you exclusive legal rights and nationwide brand protection.'
  }
];
